import React from "react";
import useReveal from "../../hooks/useReveal";
import { waUrl } from "../../config/bdk";

const projects = [
  "Sistemas web a la medida",
  "Portales de clientes",
  "Paneles administrativos / dashboards",
  "Usuarios y roles",
  "Integraciones / APIs",
  "Automatizaciones",
];

const AdvancedProjects = () => {
  useReveal();
  return (
    <section
      id="avanzados"
      data-testid="section-avanzados"
      className="bdk-section"
    >
      <div className="container-bdk grid lg:grid-cols-2 gap-14 items-center">
        <div
          className="bdk-reveal bdk-reveal--left"
          style={{ "--reveal-delay": "0ms" }}
        >
          <p className="kicker">¿Necesitas algo más avanzado?</p>
          <h2 className="font-display text-[38px] sm:text-[48px] md:text-[56px] lg:text-[64px]">
            Además de páginas web, también
            <br />
            desarrollamos <span style={{ color: "var(--red)" }}>sistemas a la medida</span>.
          </h2>
          <p className="mt-5 text-[#666873] text-[15px] md:text-[16px] max-w-[560px]">
            Si tu negocio necesita algo que no cabe en una página convencional,
            podemos desarrollar portales de clientes, paneles administrativos,
            áreas privadas, integraciones y automatizaciones adaptadas a tus
            procesos. Se revisa y cotiza según <b>alcance, complejidad y
            objetivos</b>; la propuesta visual inicial no aplica para estos
            casos.
          </p>
          <a
            href={waUrl(
              "Hola, tengo un proyecto avanzado (sistema/ecommerce/base de datos). Quiero cotizarlo con BDKSISTEMAS."
            )}
            target="_blank"
            rel="noreferrer"
            data-testid="advanced-cta"
            className="bdk-btn bdk-btn--primary bdk-btn--lg mt-7"
          >
            Cotizar proyecto personalizado
          </a>
        </div>

        <div
          className="grid grid-cols-2 gap-3 bdk-reveal bdk-reveal--right"
          style={{ "--reveal-delay": "0ms" }}
        >
          {projects.map((label, i) => (
            <div
              key={label}
              data-testid={`advanced-item-${i}`}
              className="p-5 rounded-[10px] bg-white"
              style={{
                border: "1px solid var(--line)",
                borderLeft: "4px solid var(--red)",
                boxShadow: "0 10px 30px rgba(17,18,24,.05)",
              }}
            >
              <div
                className="font-display text-[22px] font-black text-[#d90020]"
                style={{ lineHeight: 1 }}
              >
                {String(i + 1).padStart(2, "0")}
              </div>
              <p className="mt-2 font-display text-[18px] text-[#111218] leading-tight uppercase">
                {label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvancedProjects;
